import "./autoplayVideoOnScroll";
import "./burgerMenu.js";
import "./formToggle.js";
import "./handleFormSubmit.js";
import "./idFieldToggle.js";
import "./imageModal.js";
// import "./scrollMenu.js";
import "./consent.js";
// import "./react/donorForm/index.jsx";
import "./donorForm";
import "./accordions";
import "./playbook";
import "./imageSlider";
import "./newsletter";
import "./freeform";
// import "./tooltips";